import { api } from "./api";
import { demoService } from "./demoService";
import * as realInterviewService from "./interviewService";
import * as realAiService from "./aiService";

// Check if we're in demo mode based on URL path
// Demo mode is disabled - always return false
const checkDemoMode = () => {
  return false;
  // Original logic: return window.location.pathname.startsWith("/demo");
};

// Service factory that returns appropriate services based on mode
export const createServiceFactory = () => {
  const isDemo = checkDemoMode();

  return {
    // Authentication service
    auth: {
      getAuthStatus: isDemo ? demoService.getAuthStatus : api.getAuthStatus,
      signOut: isDemo ? demoService.signOut : api.signOut,
      getBaseUrl: api.getBaseUrl,
      getFrontendUrl: api.getFrontendUrl,
    },

    // Interview service
    interview: {
      getAllInterviews: isDemo
        ? demoService.getAllInterviews
        : realInterviewService.getAllInterviews,
      getInterviewsByProject: isDemo
        ? demoService.getInterviewsByProject
        : realInterviewService.getInterviewsByProject,
      updateInterviews: isDemo
        ? demoService.updateInterviews
        : realInterviewService.updateInterviews,
      updateInterview: isDemo
        ? demoService.updateInterview
        : realInterviewService.updateInterview,
      createInterview: isDemo
        ? demoService.createInterview
        : realInterviewService.createInterview,
      deleteInterview: isDemo
        ? demoService.deleteInterview
        : realInterviewService.deleteInterview,
      getOwnedProjects: isDemo
        ? demoService.getOwnedProjects
        : realInterviewService.getOwnedProjects,
      getSharedProjects: isDemo
        ? demoService.getSharedProjects
        : realInterviewService.getSharedProjects,
      getArchivedProjects: isDemo
        ? demoService.getArchivedProjects
        : realInterviewService.getArchivedProjects,
      toggleProjectStatus: isDemo
        ? demoService.toggleProjectStatus
        : realInterviewService.toggleProjectStatus,
      createProject: isDemo
        ? demoService.createProject
        : realInterviewService.createProject,
      updateProject: isDemo
        ? demoService.updateProject
        : realInterviewService.updateProject,
      syncCalendarEvents: isDemo
        ? demoService.syncCalendarEvents
        : realInterviewService.syncCalendarEvents,
      getUserProfile: isDemo
        ? demoService.getUserProfile
        : realInterviewService.getUserProfile,
      updateUserSyncTime: isDemo
        ? demoService.updateUserSyncTime
        : realInterviewService.updateUserSyncTime,
    },

    // AI service
    ai: {
      generateAnonymizedAttribution: isDemo
        ? demoService.generateAnonymizedAttribution
        : realAiService.generateAnonymizedAttribution,
      generateInterviewDescription: isDemo
        ? demoService.generateInterviewDescription
        : realAiService.generateInterviewDescription,
      batchGenerateAnonymizedAttributions: isDemo
        ? demoService.batchGenerateAnonymizedAttributions
        : realAiService.batchGenerateAnonymizedAttributions,
      parseCalendarText: isDemo
        ? demoService.parseCalendarText
        : realAiService.parseCalendarText,
      calculatePrice: isDemo
        ? demoService.calculatePrice
        : realAiService.calculatePrice,
    },

    // Utility to check if in demo mode
    isDemoMode: () => isDemo,
  };
};

// Create singleton instance
const services = createServiceFactory();

// Export individual services for easy importing
export const authService = services.auth;
export const interviewService = services.interview;
export const aiService = services.ai;
export const isDemoMode = services.isDemoMode;
